import React, { forwardRef, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { GridActionsCellItem } from "@mui/x-data-grid";
import * as Icons from "react-bootstrap-icons";
import Inputer from "Utils/Helpers/Inputer";
import { useSetState } from "Utils/Helpers/Hooks";
import { Grid2 } from "@mui/material";
import MButton from "Utils/Helpers/MButton";
import { HandleLoading } from "Utils/Helpers/ApiServices";
import { useDispatch } from "react-redux";
import { enqueueSnackbar } from "notistack";
import CheckApiStatus from "Utils/Constants/CheckApiStatus";
import { setCharacterData } from "../../../../../Redux/slices/mngrSlice";
import MFieldImage from "Utils/Helpers/MFieldImage";
import { put_characters } from "http/components/Characters";
import MuiRadioGroup from "Utils/Helpers/MuiRadioGroup";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function EditCharactersData({ row }) {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [image, setImage] = useState(null);
  const [controls, setControls] = useSetState({
    code: {
      label: "Code",
      type: "text",
      multiLine: false,
      placeholder: "Code",
      value: "",
      validation: false,
      size: { md: 4, sm: 4, xs: 12 },
    },
    name: {
      label: "Name",
      type: "text",
      multiLine: false,
      placeholder: "Name",
      value: "",
      validation: false,
      size: { md: 4, sm: 4, xs: 12 },
    },
    price: {
      label: "Price (ETH)",
      type: "number",
      multiLine: false,
      placeholder: "Price",
      value: "",
      validation: false,
      size: { md: 4, sm: 4, xs: 12 },
    },
    rarible: {
      label: "Rarible",
      type: "text",
      multiLine: false,
      placeholder: "Rarible",
      value: "",
      validation: false,
      size: { md: 12, sm: 12, xs: 12 },
    },
    status: {
      display: false,
      label: "Status",
      type: "radio",
      value: "",
      items: [
        { key: "Sellable", value: "1" },
        { key: "Sold", value: "2" },
        { key: "Unsellable", value: "3" },
      ],
      size: { md: 12, sm: 12, xs: 12 },
    },
    description_en: {
      label: "Description (en)",
      type: "text",
      multiLine: true,
      placeholder: "Description (en)",
      value: "",
      validation: false,
      size: { md: 12, sm: 12, xs: 12 },
    },
    description_fr: {
      label: "Description (fr)",
      type: "text",
      multiLine: true,
      placeholder: "Description (fr)",
      value: "",
      validation: false,
      size: { md: 12, sm: 12, xs: 12 },
    },
    description_it: {
      label: "Description (it)",
      type: "text",
      multiLine: true,
      placeholder: "Description (it)",
      value: "",
      validation: false,
      size: { md: 12, sm: 12, xs: 12 },
    },
  });

  const onEnter = () => {
    setControls({ code: { value: row.code, validation: true } });
    setControls({ name: { value: row.name, validation: true } });
    setControls({ rarible: { value: row.url || "", validation: true } });
    setControls({ price: { value: row.price, validation: true } });
    const status_value = controls.status.items.find(
      (i) => +i.value === +row.status
    );
    setControls({
      status: {
        value: status_value,
      },
    });
    setControls({
      description_en: { value: row.languages.en, validation: true },
    });
    setControls({
      description_fr: { value: row.languages.fr, validation: true },
    });
    setControls({
      description_it: { value: row.languages.it, validation: true },
    });
  };

  const setValue = (name, value, validation) => {
    let _validation = validation;
    if (name === "rarible" && !value.includes("https://rarible.com"))
      _validation = false;
    if (name === "rarible" && value === "")
      _validation = true;
    setControls({ [name]: { value, validation: _validation } });
  };

  const onChangeRadio = (name, value) => {
    setControls({ [name]: { value: value } });
  };

  const onSelectImage = (selected) => {
    setImage(selected);
  };

  const setShowDialog = () => {
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
  };

  const onSubmit = async () => {
    const {
      code,
      name,
      price,
      rarible,
      status,
      description_en,
      description_fr,
      description_it,
    } = controls;
    if (!rarible.validation) {
      enqueueSnackbar("Invalid Rarible URL", { variant: "error" });
    } else if (code.validation && price.validation) {
      dispatch(HandleLoading(true));
      let formData = new FormData();
      formData.append("id", row.id);
      formData.append("code", code.value);
      formData.append("price", price.value);
      formData.append("burl", rarible.value);
      formData.append("status", +status.value.value);
      formData.append("name", name.validation ? name.value : "");
      formData.append("image", image || "1a67d29f5");
      formData.append(
        "description",
        JSON.stringify({
          en: description_en.value ? description_en.value : "",
          fr: description_fr.value ? description_fr.value : "",
          it: description_it.value ? description_it.value : "",
        })
      );
      const response = await put_characters(formData);
      if (CheckApiStatus(response)) {
        dispatch(setCharacterData(true));
        enqueueSnackbar("Edit Success", { variant: "success" });
      }
      setShow(false);
      setImage(null);
      dispatch(HandleLoading(false));
    } else {
      enqueueSnackbar("Enter data correctly", { variant: "error" });
    }
  };

  return (
    <>
      <GridActionsCellItem
        icon={<Icons.Pencil size={16} />}
        label="Edit"
        onClick={setShowDialog}
        className="btn-manager btn-edit"
      />
      {show && (
        <Dialog
          open={show}
          TransitionComponent={Transition}
          keepMounted
          fullWidth={true}
          maxWidth={"sm"}
          onClose={handleClose}
          TransitionProps={{ onEnter: onEnter }}
          aria-describedby="alert-dialog-edit"
        >
          <DialogTitle>{`Edit (${row.code})`}</DialogTitle>
          <DialogContent>
            {show && (
              <Grid2 container spacing={2}>
                <Grid2 size={{ xs: 12 }}>
                  <MFieldImage
                    name={"Character image"}
                    image={image}
                    lastImage={row.image}
                    onChange={onSelectImage}
                  />
                </Grid2>
                {Object.keys(controls).map((key, index) => {
                  return (
                    <Grid2 size={controls[key].size} key={key + index}>
                      {["text", "number"].includes(controls[key].type) && (
                        <Inputer
                          id={key}
                          setValue={setValue.bind(this)}
                          value={controls[key].value}
                          label={controls[key].label}
                          placeholder={controls[key].placeholder}
                          type={controls[key].type}
                          multiLine={controls[key].multiLine}
                        />
                      )}
                      {controls[key].type === "radio" && (
                        <MuiRadioGroup
                          name={key}
                          value={controls[key].value}
                          label={controls[key].label}
                          items={controls[key].items}
                          onChange={onChangeRadio}
                        />
                      )}
                    </Grid2>
                  );
                })}
              </Grid2>
            )}
          </DialogContent>
          <DialogActions>
            <MButton
              label={"Close"}
              color="secondary"
              onClick={handleClose}
              className="flex-grow-1"
            />
            <MButton
              label={"Update"}
              className="flex-grow-1"
              onClick={onSubmit}
            />
          </DialogActions>
        </Dialog>
      )}
    </>
  );
}
